import Head from 'next/head';

import { StaticFile, StaticImage } from '@/common/constants/displateRoutes';
import { PageMeta } from '@/common/routes/RouteBuilder';

export const DEFAULT_COVER_IMG = StaticImage('/images/seo/default_og_image.jpeg');
export const DEFAULT_TITLE = 'Displate - metal posters | Collect Your Passions';
const OG_DEAFULT_WIDTH = '1200';
const OG_DEAFULT_HEIGHT = '630';

interface HeadMetaTagsProps {
  pageMeta: PageMeta;
  noIndex?: boolean;
  noFollow?: boolean;
  ogWidth?: string;
  ogHeight?: string;
}

export const HeadMetaTags = ({
  pageMeta,
  noIndex = false,
  noFollow = false,
  ogWidth = OG_DEAFULT_WIDTH,
  ogHeight = OG_DEAFULT_HEIGHT,
}: HeadMetaTagsProps) => {
  const robotsContent = [noIndex && 'noindex', noFollow && 'nofollow'].filter(Boolean).join(', ');
  const hasRobotsMetaTag = noIndex || noFollow;

  return (
    <Head>
      <title>{pageMeta.title}</title>
      <meta content={pageMeta.title} property="og:title" />

      <meta content={pageMeta.description} name="description"></meta>
      <meta content={pageMeta.description} property="og:description" />

      <meta content={pageMeta.coverImage} property="og:image" />
      <meta content={ogWidth} property="og:image:width" />
      <meta content={ogHeight} property="og:image:height" />
      <meta content="product" property="og:type" />

      <link
        href={StaticImage('/images/seo/apple-touch-icon.png')}
        rel="apple-touch-icon"
        sizes="180x180"
      />
      <link
        href={StaticImage('/images/seo/favicon-32x32.png')}
        rel="icon"
        sizes="32x32"
        type="image/png"
      />
      <link
        href={StaticImage('/images/seo/favicon-16x16.png')}
        rel="icon"
        sizes="16x16"
        type="image/png"
      />
      <link href={StaticFile('/seo/site.webmanifest')} rel="manifest" />
      <link
        color="#009fe3"
        href={StaticImage('/images/seo/safari-pinned-tab.svg')}
        rel="mask-icon"
      />
      <link href={StaticImage('/images/seo/favicon.ico')} rel="shortcut icon" />
      <meta content={pageMeta.title} name="apple-mobile-web-app-title" />
      <meta content={pageMeta.title} name="application-name" />

      <meta content="#ffffff" name="msapplication-TileColor" />
      <meta content="#ffffff" name="theme-color" />
      {hasRobotsMetaTag ? <meta content={robotsContent} name="robots" /> : null}
    </Head>
  );
};
